import React from 'react';
import styled from 'styled-components';
import theme from '^/theme';
import { StatusBadge } from '^/components/atoms/StatusBadge';
import RequestCountBadge from '^/components/atoms/RequestCountBadge';
import RequestIcon from '^/components/atoms/RequestIcon';
import { RequestPhotoStatus } from '^/types';

export interface PhotoRequestItemProps {
  status: RequestPhotoStatus;
  title: string;
  date: string;
  count: number;
  testId?: string;
  onClick?(): void;
}

const ItemContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  borderBottom: `1px solid ${theme.colors.coolGray[100]}`,
  cursor: 'pointer',
  backgroundColor: theme.colors.white[100],
  '&:hover': {
    backgroundColor: theme.colors.coolGray[50],
  },
});

const StatusContainer = styled.div({
  display: 'flex',
  padding: '12px 20px',
  alignItems: 'center',
  gap: '6px',
});

const ContentContainer = styled.div({
  display: 'flex',
  padding: '0 20px 12px 20px',
  alignItems: 'center',
  gap: '6px',
});

const TitleContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  minWidth: 0,
});

const Title = styled.div({
  fontSize: '14px',
  fontWeight: 500,
  color: theme.colors.coolGray[900],
  whiteSpace: 'nowrap',
  overflowX: 'clip',
  textOverflow: 'ellipsis',
});

const DateText = styled.div({
  fontSize: '10px',
  color: theme.colors.coolGray[600],
});

export const PhotoRequestItem: React.FC<PhotoRequestItemProps> = ({
  status,
  title,
  date,
  count,
  testId,
  onClick,
}) => (
  <ItemContainer onClick={onClick} data-testid={testId}>
    <StatusContainer>
      <StatusBadge type={status} testId={`${testId}-status-badge`} />
      <DateText>{date}</DateText>
    </StatusContainer>
    <ContentContainer>
      <RequestIcon testId={`${testId}-icon`} />
      <TitleContainer>
        <Title>{title}</Title>
      </TitleContainer>
      <RequestCountBadge count={count} testId={`${testId}-count-badge`} />
    </ContentContainer>
  </ItemContainer>
);

export default PhotoRequestItem;
